var lib_core = require("lib-core");

var SidebarModel = function () {
    var self = this;
    lib_core.Model.call(this);

    this.show = this.value("show", true);
};

lib_core.inherit(SidebarModel, lib_core.Model);
SidebarModel.$class = "SidebarModel";

module.exports = SidebarModel;